export default __webpack_public_path__ + "static/media/tom.45b5dbf6.png";